module.exports = __webpack_public_path__ + "static/media/fire.673d53c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/lib/elements/fire.svg
// module id = 79
// module chunks = 0